import { ElementSource, MediaVersion } from "chq";
import { isEqual } from "lodash";
import { VIDEO_TYPE } from "components/stories/video-studio/utils/constants";
import { isStoryElement } from "components/stories/video-studio/utils";
import isSubtitleText from "./isSubtitleText";

const needToBlockSubtitles = (
  creatomateJson: ElementSource, lastMediaVersion: MediaVersion
): boolean => {
  const { elements: currentElements } = creatomateJson;

  const hasSutbtitles = currentElements?.some((element: ElementSource) => (
    isSubtitleText(element.name)
  ));
  if (hasSutbtitles) return false;

  if (!lastMediaVersion) {
    const videoElement = creatomateJson?.elements?.sort(
      (first: ElementSource, second: ElementSource) => (first.time - second.time)
    )?.find((element: ElementSource) => (
      element.type === VIDEO_TYPE && isStoryElement(element)
    ));
    if (videoElement?.trim_start || videoElement?.time) {
      return true;
    }

    return false;
  }

  const lastMediaVersionJson = lastMediaVersion.additionalData;
  const { elements: lastVersionEl } = lastMediaVersionJson || {};

  const currentVideoElements = currentElements?.filter((element: ElementSource) => (
    element.type === VIDEO_TYPE
  )).map((element: ElementSource) => ({
    id: element.id,
    time: element.time,
    trim_start: element.trim_start,
    duration: element.duration
  })).sort((a: any, b: any) => (a.id).localeCompare(b.id));

  const originalVideoElements = lastVersionEl?.filter((element: ElementSource) => (
    element.type === VIDEO_TYPE
  )).map((element: ElementSource) => ({
    id: element.id,
    time: element.time,
    trim_start: element.trim_start,
    duration: element.duration
  })).sort((a: any, b: any) => (a.id).localeCompare(b.id));

  return !isEqual(currentVideoElements, originalVideoElements);
};

export default needToBlockSubtitles;
